import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AppSettingsService, SubdomainEnum } from '../services/app-settings.service';
import { RoutingService } from '../services/routing.service';

@Injectable({
  providedIn: 'root'
})
export class SubdomainGpGuard  {
  constructor(
    private appSettingsService: AppSettingsService,
    private routingService: RoutingService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // if user tries to access a GP page on the LP subdomain or vice versa, navigate him to the other login page.
    if (this.appSettingsService.subDomain === SubdomainEnum.LP) {
      return this.routingService.getLoginUrlTree(true);
    } else {
      return true;
    }
  }
}
